import React from 'react';
import { useTranslation } from 'react-i18next';
import Menu from '../../components/Menu'
import Header from '../../components/Header'
import { ReactComponent as IconTemperature } from '../../images/icn-temperature.svg'
import { Card, CardBody } from 'reactstrap'
import Footer from '../../components/Footer'
import BurgerMenu from '../../components/BurgerMenu'
import IotTable from './IotTable';

function IotPresentational(props) {
  const {
    deals,
    total = 0,
    query = {},
    onFilter,
    isLoading = false,
  } = props;

  const [t] = useTranslation('COMMON');

  return (
    <div className="App">
      <Menu />

      <div className="corpo">
        <section>
          <Header
            title={t('TEMPERATURES')}
            icon={<IconTemperature fill='#FF6B38' />}
          />

          {/* <div className="row">
            <div className="col-6">
              <Button className="btn-collapse" id="toggler" style={{ marginBottom: '1rem' }}>
                {t('COMMON:FILTER_BY')} <i className="fas fa-filter"></i>
              </Button>
            </div>
            <div className="col-6 text-right">
            </div>
          </div>

          <UncontrolledCollapse toggler="#toggler">
            <div className="m-t-20">
              <Filters
                query={query}
                onFilter={onFilter}
              />
            </div>
          </UncontrolledCollapse> */}

          <hr />

          <Card>
            <CardBody>
              <IotTable
                deals={deals}
                total={total}
                query={query}
                onFilter={onFilter}
                isLoading={isLoading}
              />
            </CardBody>
          </Card>

        </section>
        <Footer />
      </div>

      <BurgerMenu />
    </div >
  )
}

export default IotPresentational
